export enum BetBuilderActionsTypeEnum {
	AddToSlip = "BB-add-to-slip",
	OpenBBwithShortcut = "BB-shortcut-used",
	BBTabOpen = "BB-tab-open",
}
